module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c011"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('b', [_vm._v("1770")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("The “Mechanical Turk”")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("Wolfgang von Kempelen")]), _vm._v(" (1734–1804)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("After seeing an illusionist perform at Austria’s Schönbrunn Palace in 1770, Hungarian inventor Wolfgang von Kempelen told the Empress Maria Theresa of Austria that he could create something even better. The empress gave Kempelen six months to top the illusionist’s act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Industrial Revolution was well underway in 1770, and it was in this environment that Kempelen created an elaborate hoax that alleged to be a “thinking” machine. With expertise in hydraulics, physics, and mechanics, Kempelen returned to the court with an automaton that he claimed could best human chess masters and complete a complex puzzle called the Knights Tour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kempelen’s “Mechanical Turk,” as it came to be known, was a life-size model of a man’s upper half. Dressed in Ottoman robes with a turban and black beard, a smoking pipe in its left hand, the Turk sat at a cabinet with three doors and a chessboard on top. The doors opened to show an intricate set of gears and levers designed to give the audience the illusion of an advanced contraption worthy of the owner’s claims. What remained hidden was a sliding seat behind the gears that enabled a small human chess player to move around as Kempelen showed suspicious spectators the cabinet’s inside, and then to manipulate the contraption once the game began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Turk beat almost everyone it played against, including Benjamin Franklin, who was the US ambassador to France at the time. It also beat the novelist Edgar Allan Poe, as well as Napoléon Bonaparte, whose strategy to beat the Turk was to make a series of deliberately illegal moves. The Turk replaced Napoléon’s piece after the first two moves, and then, after the third, swept its arm across the chessboard, knocking over all of the pieces and ending the game. Napoléon reportedly was amused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real or not, the Turk started new dialogue among those who had never considered the potential of mechanized intelligence. Among those was Charles Babbage, whom the Turk beat twice, and who, despite correctly concluding the device was a hoax, drew inspiration from the experience and went on to build the difference engine, the first mechanical computer. The Turk was destroyed in a fire in Philadelphia on July 5, 1854.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c014_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Difference Engine (1822)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c018_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edgar Allan Poe’s “The Gold-Bug” (1843)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c212_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Computer Is World Chess Champion (1997)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("Instead of a machine, a small chess master hid inside the cabinet that held the “Mechanical Turk.” To conceal his presence, the person moved from side to side as the different panel doors were opened.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/37-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f048396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c011_r1.vue
// module id = 105
// module chunks = 0